import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class MobileAppManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/mobile-apps',
      params,
      paramsSerializer: qs.stringify,
    });

  getBoard = (params) =>
    this.request({
      method: 'GET',
      url: '/mobile-apps',
      params,
      paramsSerializer: qs.stringify,
    });

  getBoardCounts = (params) =>
    this.request({
      method: 'GET',
      url: '/mobile-apps/board-counts',
      params,
      paramsSerializer: qs.stringify,
    });

  updateReleaseStatus = (id, data) =>
    this.request({
      method: 'PATCH',
      url: `/mobile-apps/${id}/release-status`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/mobile-apps/${id}`,
    });

  getGroupedStats = (params) =>
    this.request({
      method: 'GET',
      url: '/mobile-apps/grouped-stats',
      params,
    });

  getStats = (params) =>
    this.request({
      method: 'GET',
      url: '/mobile-apps/stats',
      params,
    });

  getUpdates = (params) =>
    this.request({
      method: 'GET',
      url: '/mobile-app-updates',
      params,
      paramsSerializer: qs.stringify,
    });

  postUpdate = (data) =>
    this.request({
      method: 'POST',
      url: '/mobile-app-updates',
      data,
    });
}
